export default __webpack_public_path__ + "static/abstract-blocks-right-d36f15c80b78059445fedf71ead4ba6f.svg";